<mat-tab-group dynamicHeight class="bloco-detalhes" [selectedIndex]="tabIndex" (focusChange)="changeEvent($event)">
  <mat-tab class="remetente" label="Remetente e Destinatário">
    <ng-template matTabContent>
      <div class="p-3">
        <app-bloco-remetente-destinatario [Pedido]="pedido"></app-bloco-remetente-destinatario>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab class="origem-pedido" label="NRTs Relacionadas">
    <ng-template matTabContent>
      <div class="p-3 ">
        <div class="bloco-unico">
          <div class="container rastreamento-eventos">
              <app-bloco-reentrega-interno [Pedido]="pedido"></app-bloco-reentrega-interno>
          </div>
        </div>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab class="rastreamento" label="Rastreamento">
    <ng-template matTabContent>
      <div class="p-3 ">
        <div class="bloco-unico">
          <app-etapa-rastreamento [Pedido]="pedido.tracking"></app-etapa-rastreamento>
          <div class="container rastreamento-eventos">
            <details>
              <summary class="table-info">
                <mat-icon>info</mat-icon>
                <span>Ver todos os eventos deste pedido</span>
              </summary>
              <section>
                  <app-bloco-historico-consulta [PedidoId]="pedido.pedidoId"></app-bloco-historico-consulta>
              </section>
            </details>
          </div>
        </div>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab class="rat" label="RAT">
    <ng-template matTabContent>
      <div class="p-3 ">
        <app-bloco-rat [Pedido]="pedido"></app-bloco-rat>
        <div class="bg-white d-flex justify-content-center py-3">
          <a mat-flat-button color="primary" style="width: 267px;" class="external"
            [href]="getRatLink(pedido?.pedidoId)">
            Visualizar RAT <i class="fas fa-external-link-square"></i>
          </a>
        </div>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab class="comprovante" label="Comprovante de baixa online">
    <ng-template matTabContent>
      <div class="p-3">
        <app-bloco-comprovante [Pedido]="pedido"></app-bloco-comprovante>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab label="Observações e Comentários">
    <ng-template matTabContent>
      <div class="p-3">
        <app-bloco-observacao-comentario [Pedido]="pedido"></app-bloco-observacao-comentario>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab class="imprimir" label="Imprimir">
    <ng-template matTabContent>
      <div id="imprimir" class="p-3">
        <app-bloco-imprimir [Pedido]="pedido"></app-bloco-imprimir>
        <div class="d-flex justify-content-center py-3">
          <button mat-flat-button class="btn btn-success no-print" (click)="imprimir()">
            IMPRIMIR <i class="fas fa-print"></i>
          </button>
        </div>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
